<script setup>
import { Link, usePage } from '@inertiajs/vue3';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
    <div class="py-10 lg:py-2 bg-secondary">
        <div class="container flex items-center h-full">
            <div class="flex flex-col items-center justify-between w-full gap-10 lg:gap-4 lg:flex-row">
                <div class="flex flex-col items-center gap-4 lg:flex-row lg:order-2">
                    <!-- <Link :href="usePage().props.cms_settings.terms_page_url" class="transition duration-300 group">
                        {{ t('Terms and Conditions') }}
                        <span
                            class="block max-w-8 group-hover:max-w-16 transition-all duration-500 h-[1px] bg-primary"
                        ></span>
                    </Link> -->
                    <Link :href="usePage().props.cms_settings.privacy_page_url" class="transition duration-300 group">
                        {{ t('Privacy declaration') }}
                        <span
                            class="block max-w-8 group-hover:max-w-16 transition-all duration-500 h-[1px] bg-primary"
                        ></span>
                    </Link>
                </div>

                <span class="transition-colors duration-300 md:text-right hover:text-secondary lg:order-1">
                    {{ t('Made by:') }}
                    <a
                        href="https://strixi.nl?utm_source=Developed+sites&utm_medium=Website&utm_campaign=Footer"
                        target="_blank"
                        class="font-bold"
                        >STRIXI</a
                    >
                </span>
            </div>
        </div>
    </div>
</template>
